import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { authService } from '@/api/services';
import { useAuthStore } from '@/store';
import { loginPath, safeReturnTo } from '@/utils/loginRedirect';

/** Magic-link landing: /auth/email/confirm?token=... */
export const AuthEmailConfirmPage: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthTokens } = useAuthStore();
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setError('В ссылке нет токена');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await authService.emailConfirm({ token });
        if (cancelled) return;
        setAuthTokens(res.accessToken, res.refreshToken);
        setDone(true);
        navigate(safeReturnTo(params.get('returnTo')), { replace: true });
      } catch {
        if (!cancelled) setError('Ссылка недействительна или уже использована');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [params, navigate, setAuthTokens]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
      <Box sx={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
        {!error && !done && (
          <>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography>Вход по ссылке…</Typography>
          </>
        )}
        {error && (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Откройте приложение и введите код из письма — так надёжнее в PWA на iOS.
            </Typography>
            <Button component={Link} to={loginPath()} variant="contained">
              Перейти ко входу
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};
